import {
  PanelType,
  TabsConfig,
  TechDocsCustomHome,
} from '@backstage/plugin-techdocs';

const tabs: TabsConfig = [
  {
    label: 'All Docs',
    panels: [
      {
        title: 'Documentation',
        description:
          "All technical documentation across AppFolio's domains, systems, and components",
        panelType: 'DocsTable' as PanelType,
        panelCSS: { overflow: 'auto' },
        filterPredicate: () => true,
      },
    ],
  },
];

export const TechDocsHomePageContent = () => (
  <TechDocsCustomHome tabsConfig={tabs} />
);
